module.exports = __webpack_public_path__ + "static/media/card_bg_9.290bf6bd.png";